export const addQueryStringParams = (url: string, params: { [key: string]: string }): string => {
	let newUrl = url;
	let isFirstParam = false;
	const querySymbolPosition = url.indexOf('?');

	if (querySymbolPosition === -1) {
		newUrl += '?';
		isFirstParam = true;
	} else if (querySymbolPosition === url.length - 1) {
		isFirstParam = true;
	}

	Object.keys(params)
		.forEach((key: string, index: number) => {
			const reg = new RegExp(`([?&])${key}=[^&]*`);

			if (!url.match(reg)) {
				if (!isFirstParam) {
					newUrl += '&';
				}

				newUrl += `${key}=${params[key]}`;
			} else {
				newUrl = newUrl.replace(reg, `$1${key}=${params[key]}`);
			}

			isFirstParam = false;
		});

	return newUrl;
};